<template>
  <div
    class="cn-parallelogram"
    :class="[
      { [`cn-parallelogram--${color}`]: color },
      { [`cn-parallelogram--filled`]: filled },
    ]"
  ></div>
</template>

<script setup lang="ts">
interface Props {
  color?: 'gray' | 'yellow' | 'aqua' | 'white';
  filled?: boolean;
}

defineProps<Props>();
</script>

<style lang="scss">
.cn-parallelogram {
  --ab-canyon-parallelogram-color-border: transparent;

  border-width: 2px;
  border-color: var(--ab-canyon-parallelogram-color-border);
  transform: rotate(30deg) skewY(-30deg);
  flex-shrink: 0;
  margin-left: calc(var(--size-base) / 2);
  margin-right: calc(var(--size-base) / 2);
  &--filled {
    background-color: var(--ab-canyon-parallelogram-color-border);
  }
  &--gray {
    --ab-canyon-parallelogram-color-border: var(--ab-canyon-color-neutral-dark);
  }
  &--yellow {
    --ab-canyon-parallelogram-color-border: var(--ab-canyon-color-accent-2);
  }
  &--aqua {
    --ab-canyon-parallelogram-color-border: var(--ab-canyon-color-accent-4);
  }
  &--white {
    --ab-canyon-parallelogram-color-border: var(--ab-canyon-color-light);
  }
}
</style>
